<template>
  <div class="page-booking">
    <div class="search-box">
      <div class="search">
        <input type="text" class="ipt" :placeholder="`热门搜索：${hotSearch}`" v-model="searchText" @keyup.enter="toSearch" />
        <div class="btn-search" @click="toSearch">
          <img class="icon" src="../assets/icons/icon_search.png" alt="">
        </div>
      </div>
    </div>
    <swiper class="menu-list" :options="swiperOption">
      <swiper-slide
        :class="['menu-item', {active: item.value === menuActive}]"
        v-for="item in menu"
        :key="item.value">
        <div @click="menuClick(item.value)">
          <img class="icon" :src="require(`../assets/icons/index_menu${item.icon}${item.value === menuActive ? '_cur' : ''}.png`)" alt="">
          <p class="name">{{item.name}}</p>
        </div>
      </swiper-slide>
    </swiper>
    <div class="tip" v-if="bookingRemind">
      <img class="icon" src="../assets/icons/icon_horn.png" alt="">
      <p class="text el">{{bookingRemind}}</p>
      <div class="btn-close" @click="$store.commit('store', { bindTicket: { bookingRemind: '' } })">
        <van-icon class="icon-close" name="cross" />
      </div>
    </div>
    <van-image class="banner" :src="require(`../assets/booking_banner/${menuActive}.jpg`)" />
    <normal-list ref="normalList" v-show="!isTravel" :type="type" />
    <booking-travel v-show="isTravel" />
    <!-- footer -->
    <base-footer />
  </div>
</template>

<script>
import { serviceMenu } from '@/utils/dict'
import { orderBy } from 'lodash'
import BookingNormalList from './booking/BookingNormalList'
import BookingTravel from './booking/BookingTravel'
import BaseFooter from '../components/BaseFooter'
import { mapGetters } from 'vuex'
import api from '@/api'
import { toShoppingMall } from '@/plugins/common'

export default {
  name: 'PageBooking',

  components: {
    'normal-list': BookingNormalList,
    BookingTravel,
    BaseFooter
  },

  props: {
    type: String
  },

  beforeRouteLeave (to, from, next) {
    if (to.path.indexOf('product/detail') > 0) {
      this.$store.commit('storeBookingPageData', {
        shipCode: this.$refs.normalList.shipCode,
        classifyActive: this.$refs.normalList.classifyActive
      })
    } else {
      this.$store.commit('storeBookingPageData', '')
    }
    next()
  },

  data () {
    const initMenu = serviceMenu.find(x => x.value === this.type && x.bookingIndex !== '')
    return {
      swiperOption: {
        freeMode: true,
        slidesPerView: 'auto',
        resistanceRatio: 0
      },
      menuActive: initMenu ? initMenu.value : serviceMenu[0].value,
      searchText: '',
      hotSearch: ''
    }
  },

  watch: {
    type (newVal) {
      this.menuActive = newVal
      this.bindGio()
    }
  },

  computed: {
    ...mapGetters(['bookingRemind']),
    menu () {
      return orderBy(serviceMenu.filter(x => x.bookingIndex !== ''), ['bookingIndex'])
    },
    isTravel () {
      return this.menuActive === 'pcpShorex'
    }
  },

  async mounted () {
    const { data } = await api.getHotSearch()
    if (data.length) this.hotSearch = data.join(' ')
    this.bindGio()
  },

  methods: {
    bindGio () {
      try {
        window.gio('page.set', 'Product_Category', this.type)
      } catch (error) {
        console.log(error)
      }
    },
    toSearch () {
      if (!this.searchText.trim()) return
      this.$router.push(`/product_search?keyword=${this.searchText}`)
    },
    menuClick (value) {
      if (value === this.menuActive) return
      if (value === 'hjsc') {
        toShoppingMall()
      } else {
        this.$router.replace(`/Rccl.PCP/product/${value}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-box {
  padding: 25px 36px 28px;
  .search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 72px;
    padding: 0 0 0 46px;
    border-radius: 36px;
    font-size: 24px;
    color: @main-gray4;
    background-color: #fff;
    .ipt {
      flex: 1;
      height: 34px;
      margin-top: 3px;
      padding-right: 24px;
      font-size: 24px;
      color: #333;
      line-height: 34px;
      border: none;
      outline: none;
    }
    .btn-search {
      flex: none;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 72px;
      height: 72px;
      padding-right: 20px;
      .icon {
        flex: none;
        width: 29px;
      }
    }
  }
}
.menu-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 144px;
  box-sizing: border-box;
  border-bottom: 3px solid #fff;
  background-color: #fff;
  &.active {
    border-color: #1174b8;
    .name {
      color: @main-gray2;
    }
  }
  .icon {
    display: block;
    height: 42px;
    margin: 0 auto;
  }
  .name {
    margin-top: 14px;
    font-size: 28px;
    color: @main-gray4;
  }
}
.tip {
  display: flex;
  align-items: center;
  height: 90px;
  padding: 0 20px 0 18px;
  font-size: 24px;
  color: @main-gray2;
  background-color: #fbc300;
  .icon {
    flex: none;
    width: 24px;
    margin-right: 8px;
  }
  .btn-close {
    flex: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 42px;
    height: 42px;
    margin-left: 30px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, .1);
    .icon-close {
      font-size: 22px;
    }
  }
}
.banner {
  display: block;
  width: 100%;
}
</style>
